// @ts-check
export const formatSystemReport = systemReport => ({
    id: systemReport.Id,
    name: systemReport.Name,
});
